import { render, staticRenderFns } from "./editSaleDiscount.vue?vue&type=template&id=3dab7bcf&scoped=true&"
import script from "./editSaleDiscount.vue?vue&type=script&lang=js&"
export * from "./editSaleDiscount.vue?vue&type=script&lang=js&"
import style0 from "./editSaleDiscount.vue?vue&type=style&index=0&id=3dab7bcf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dab7bcf",
  null
  
)

export default component.exports